require('./inc/site.js');
require('./inc/quantity.js');
require('./inc/productSlider.js');
require('./inc/jquery.bxslider.js');
require ('./inc/jquery.selectric.js');
require ('./inc/swipebox.js');

var tabHeaders = undefined;
var tabContents = undefined;

var productCategorySlider = undefined;
var heliumQuantity = undefined;
var previewImage = undefined;
var thumbnailSliderContainer = undefined;
var thumbnailSlider = undefined;
var quantityRemodal = undefined;

$(document).ready(function(){
  tabHeaders = $.find('[data-purpose="product-tab-header"]');
  tabContents = $.find('[data-purpose="product-tab-content"]');
  thumbnailSliderContainer = $('#thumbnailSlider');
  quantityRemodal = $('[data-remodal-id="quantity-remodal"]');

  if (tabContents.length > 0 && tabContents.length == tabHeaders.length) {
    $(tabHeaders).click(function(){
      if (!$(this).hasClass('selected')) {
        changeProductTab($(this));
      }
    });
  }

  $('[data-purpose="custom-select-container"]').selectric({
    'arrowButtonMarkup':'<svg class="icon arrow-down"><use xlink:href="#arrow-down" /></svg>'
  });

  if (thumbnailSliderContainer && thumbnailSliderContainer.length > 0) {
    initThumbnailSlider();
  }

  productCategorySlider = new ProductSlider($('#categoryProductsSlider'), {
    breakpoint:1024
  });

  heliumQuantity = $('[data-purpose="helium-quantity-outer"]');
  if (heliumQuantity.length > 0) {
    $('[data-purpose="helium-chk"]').change(function(){
      var checked = $(this).prop('checked');
      if (checked) {
        heliumQuantity.fadeIn(300);
      } else {
        heliumQuantity.fadeOut(300);
      }
    });
  }

  previewImage = $('[data-purpose="preview-image"]');
  if (previewImage && previewImage.length > 0) {
    $('[data-purpose="thumbnail-image"]').click(function(){
      previewImage.attr('src', $(this).data('preview-image'));
	   $('.swipebox').attr('href', $(this).data('preview-image'));
    });
  }

	$('[data-purpose="call-me-later"]').click(function(){
		var prod_id = $(this).attr('id');
		var notification_remodal = $('[data-remodal-id="notification-remodal"]').remodal();
		notification_remodal.open();
		$('input[name="tid"]').val(prod_id);
	});

  $('[data-purpose="cart-button"]').click(function(){
    $('[data-remodal-id="quantity-remodal"]').remodal().open();
  });

  if (quantityRemodal && quantityRemodal.length > 0) {
    quantityRemodal.find('[data-purpose="confirm-button"]').click(function(){
        $.ajax({
			url: "ajax/checkquantity.php",
			type: "post",
			data: {termek_id: prid, k_menny: keszlet},
			dataType: "json"
		})
		.done(function (data){
			if (data['ok'] == "true") {
				var notyf = new Notyf();
				$('.minicart').html(data['cartview']);
				// $('minicart').append(data['om']);
				notyf.confirm('A termék kosárba helyezve');
			}
		});
		quantityRemodal.remodal().close();
    });

    quantityRemodal.find('[data-purpose="cancel-button"]').click(function(){
      console.log('nem kéri');
      quantityRemodal.remodal().close();
    });
  }

var resizeFn = function() {
    initThumbnailSlider();
  }

  window.addEventListener('resize', resizeFn);

	
	$('.prod-quantity').change(function() {
		var csomperdb = $('[data-type="helium"]').attr('data-pckperpc');
		var menny = $('.form-content').find($('[data-purpose="quantity"]')).val();
		var maxhelium = parseInt(csomperdb * menny);
		$('[data-type="helium"]').attr('data-max-helium', maxhelium);
	});
	
	$('[data-type="helium"]').change(function() {
		var heliuminp = $('[data-type="helium"]');
		var heliumdb = heliuminp.val();
		var maxhelium = heliuminp.attr('data-max-helium');
		var panel = heliuminp.parents('[data-purpose="quantity-control-panel"]');
		var plus = panel.find('[data-purpose="quantity-change-button"][data-type="plus"]');
		if (heliumdb == maxhelium) {
			if (panel && panel.length == 1) { 
				if (plus && plus.length == 1) {
					plus.addClass('inactive');
				}
			}
		}
		else {
			if (plus.hasClass('inactive')) {
				plus.removeClass('inactive');
			}
		}
	});
	
	$('.ccc').click(function() {
		var url = $(this).children().attr("href")
		if($(this).data('state') != 'checked'){
			location.replace(url);
		}
	});
	
	
  
});

function changeProductTab(tab) {
  if (tabHeaders && tabContents) {
    $(tabHeaders).removeClass('selected');
    $(tabContents).removeClass('selected');
    if (tab) {
      var type = tab.data('type');
      tab.addClass('selected');
    }

    $.each(tabContents, function(){
      if ($(this).data('type') == type) {
        $(this).addClass('selected');
      }
    });
  }
}

function initThumbnailSlider() {
  if (thumbnailSliderContainer && thumbnailSliderContainer.length > 0) {
    if (typeof thumbnailSlider !== 'undefined') {
      thumbnailSlider.destroySlider();
    }
    var fromWidth = parseInt(thumbnailSliderContainer.data('from-width'));
    if (isNaN(fromWidth)) {
      fromWidth = 768;
    }

    if (fromWidth >= window.innerWidth) {
      var touchDevice = false;
      if (navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/)) {
        touchDevice = true;
      }

      thumbnailSlider = thumbnailSliderContainer.bxSlider({
        auto:true,
        pause:10000,
        infiniteLoop: true,
        touchEnabled: touchDevice,
        preventDefaultSwipeX: true,
        preventDefaultSwipeY: false,
        controls: false,
      });
    }
  }
}
